
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import Card from '../shared/components/Card.js';
import Heading from '../shared/components/Heading.js';
import Button from '../shared/components/Button.js';
import "../shared/css/index.css"
import { Playground, PropsTable } from 'docz'

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>

<MDXTag name="h1" components={components} props={{"id":"card"}}>{`Card`}</MDXTag>
<MDXTag name="p" components={components}>{`Card es un componente para agrupar contenido importante, como formularios o textos. No tiene ningún tamaño pretederminado, se ajusta a sus contenidos interiores, por lo que hay que modificarlo con clases de Bootstrap externas.`}</MDXTag>
<Playground __position={0} __code={'() => {\n  return (\n    <div style={{ maxWidth: 600, margin: \'auto\' }}>\n      <Card>\n        <Heading>Hola!</Heading>\n        <Button>Iniciar sesión</Button>\n      </Card>\n    </div>\n  )\n}'} __scope={{props: this ? this.props : props,Card,Heading,Button}}>
  {
    () => {
      return (
        <div style={{ maxWidth: 600, margin: 'auto' }}>
          <Card>
            <Heading>Hola!</Heading>
            <Button>Iniciar sesión</Button>
          </Card>
        </div>
      )
    }
  }
</Playground>
<PropsTable of={Card} />
           </MDXTag>
  }
}
  